export default __webpack_public_path__ + "static/iphoneX-a34223aa0e9bd4faceaa3e3614e04832.png";